import { inject, injectable } from 'inversify';
import BrandsRepository from '../../data/BrandsRepository';
import { AppSubdomains } from 'src/types/common';

type GetBrandsUseCaseProps = {
  subdomain?: AppSubdomains;
};

@injectable()
class GetBrandsUseCase {
  @inject(BrandsRepository) private brandsRepository!: BrandsRepository;

  async execute({ subdomain }: GetBrandsUseCaseProps) {
    return await this.brandsRepository.getBrands({
      subdomain,
    });
  }
}

export default GetBrandsUseCase;
